import { type ApiMessageType, type ApiMessage } from '@app/types'
import { Text } from '@mantine/core'
import { notifications, type NotificationProps } from '@mantine/notifications'

import { IconCheck, IconExclamationCircle, IconInfoCircle } from '@tabler/icons-react'
import { each, includes } from 'lodash'

const notificationProps: Record<ApiMessageType, Omit<NotificationProps, 'message'>> = {
  error: {
    autoClose: false,
    color: 'red',
    icon: <IconExclamationCircle />,
    withCloseButton: true
  },
  info: {
    autoClose: true,
    color: 'blue',
    icon: <IconInfoCircle />,
    withCloseButton: false
  },
  success: {
    autoClose: true,
    color: 'green',
    icon: <IconCheck />,
    withCloseButton: false
  },
  warning: {
    autoClose: false,
    color: 'orange',
    icon: <IconExclamationCircle />,
    withCloseButton: true
  }
}

export const showMessageNotification = ({ message, type }: ApiMessage) =>
  notifications.show({
    ...notificationProps[type],
    autoClose: includes(['success', 'info'], type),
    message: <Text dangerouslySetInnerHTML={{ __html: message }} />,
    style: {
      zIndex: 1003
    },
    withBorder: true
  })

export const showMessagesNotifications = (messages?: ApiMessage[]) => each(messages, showMessageNotification)
